import e from "react";
import { c as d, t as p } from "./useKeyDown-88662051.mjs";
import { V as y, a as B } from "./Video-83c15c06.mjs";
import { B as s } from "./useClickOutside-55c64a80.mjs";
import { I as T, a as f } from "./Image-be3826ec.mjs";
import "./ImageContext-57256dc1.mjs";
const W = "mouse", k = "mouse__icon", w = "mouse__wheel", x = "wheelUpDown", a = {
  mouse: W,
  mouseIcon: k,
  mouseWheel: w,
  wheelUpDown: x
};
function A() {
  return /* @__PURE__ */ e.createElement("div", { className: a.mouse }, /* @__PURE__ */ e.createElement("div", { className: a.mouseIcon }, /* @__PURE__ */ e.createElement("span", { className: a.mouseWheel })));
}
const S = "hero", v = "hero__block-auto", O = "hero__wrapper", P = "hero__overlay", b = "hero__content", C = "desktop", I = "hero__buttons", L = "hero__title", V = "hero__title--lead-text", H = "hero--align-bottom", R = "hero__scroll-wheel", t = {
  hero: S,
  heroBlockAuto: v,
  heroWrapper: O,
  heroOverlay: P,
  heroContent: b,
  desktop: C,
  heroButtons: I,
  heroTitle: L,
  heroTitleLeadText: V,
  heroAlignBottom: H,
  heroScrollWheel: R
};
function G({
  heading: u,
  leadText: c,
  imageAltText: h,
  videoAltText: m,
  buttons: _,
  video: o,
  assetType: l,
  imageData: r,
  viewport: n,
  credits: i
}) {
  const E = Array.isArray(o) ? o.find((N) => n && N.device?.includes(n)) : o, g = (l === "image" ? [h, i] : [m, E?.credits]).filter(Boolean).join(" - ");
  return /* @__PURE__ */ e.createElement(
    s,
    {
      topPadding: s.Padding.NONE,
      bottomPadding: s.Padding.NONE,
      "data-testid": "hero-block"
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: t.hero,
        "data-testid": "hero",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      l === "image" && r && /* @__PURE__ */ e.createElement(
        T,
        {
          credits: i,
          src: r.imageSrc,
          width: r.width,
          height: r.height,
          altText: h ?? "",
          imageLoader: r.imageLoader,
          styling: f.HERO
        }
      ),
      o && l === "video" && /* @__PURE__ */ e.createElement(
        y,
        {
          title: m ?? "",
          autoplay: !0,
          videoType: "asset",
          video: o,
          styling: B.HERO,
          viewport: n
        }
      ),
      /* @__PURE__ */ e.createElement("div", { className: t.heroOverlay, title: g }),
      /* @__PURE__ */ e.createElement(s.Content, { className: t.heroBlockAuto }, /* @__PURE__ */ e.createElement("div", { className: t.heroWrapper }, /* @__PURE__ */ e.createElement("div", { className: t.heroContent }, /* @__PURE__ */ e.createElement(
        "h1",
        {
          className: d(p.heroText, t.heroTitle),
          itemProp: "name"
        },
        u
      ), c && /* @__PURE__ */ e.createElement(
        "p",
        {
          className: d(
            p.textsLeadText,
            t.heroTitle,
            t.heroTitleLeadText
          ),
          itemProp: "description"
        },
        c
      ), /* @__PURE__ */ e.createElement(
        "span",
        {
          className: t.heroButtons,
          "data-testid": "hero-button-container",
          itemProp: "description"
        },
        _
      )))),
      /* @__PURE__ */ e.createElement(s.Content, { className: t.heroAlignBottom }, /* @__PURE__ */ e.createElement("div", { className: t.heroScrollWheel }, /* @__PURE__ */ e.createElement(A, null)))
    )
  );
}
export {
  G as Hero
};
//# sourceMappingURL=Hero.js.map
